<template>
  <RevDrawer :name :title="i18n(translations.modalName)">
    <template #body>
      <div class="space-y-24">
        <RevIllustration
          alt=""
          class="w-full"
          :height="150"
          src="/img/insurance/backupModalHeader.png"
          :width="330"
        />

        <BenefitsTable>
          <template #firstColumnTitle>
            <RevIllustration
              alt=""
              class="inline-block align-middle"
              :height="27"
              src="/img/insurance/backUpLogo.svg"
              :width="80"
            />
          </template>
          <template #secondColumnTitle>
            <div class="text-static-default-hi body-1">
              {{ i18n(translations.warranty) }}
            </div>
          </template>

          <template #rows>
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="true"
              :title="i18n(translations.comparisonTable1)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable2)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable3)"
            />
            <BenefitRow
              :isFirstOptionChecked="true"
              :isSecondOptionChecked="false"
              :title="i18n(translations.comparisonTable4)"
            />
          </template>
        </BenefitsTable>

        <ServiceDrawerFaq />
      </div>
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import BenefitRow from '../components/BenefitRow/BenefitRow.vue'
import BenefitsTable from '../components/BenefitsTable/BenefitsTable.vue'

import translations from './ServiceDrawer.translations'
import ServiceDrawerFaq from './components/ServiceDrawerFaq/ServiceDrawerFaq.vue'

defineProps<{ name: string }>()

const i18n = useI18n()
</script>
